import React, {memo, useCallback, useState} from "react"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {useLocalization} from "../../../../hooks/localization"
import {SettingCheckBoxComponent} from "../../../../components/Settings/SettingCheckboxComponent"
import {useSelector} from "react-redux"
import {useRPC} from "../../../../hooks/rpc"
import {useMessage} from "../../../../hooks/message"
import {useQuestion} from "../../../../hooks/question"

export const AdvancedPanelSettings = memo(function AdvancedPanelSettings() {
    const {t} = useLocalization()
    const mousePointerStatus = useSelector(state => state.control.mousePointerStatus)
    const {failure} = useMessage()
    const question = useQuestion()
    const [rpc] = useRPC()
    const [mousePointer, setMousePointer] = useState(mousePointerStatus || false)
    const onChangeMousePointer = useCallback(() => {
        question(t("the_window_will_reload"), () => {
            let newStatus = mousePointer
            if (newStatus) {
                newStatus = false
            } else {
                newStatus = true
            }
            setMousePointer(newStatus)
            rpc.updateMouseCursorVisibility(newStatus).catch(failure)
        })
    }, [t, question, failure, rpc, mousePointer])

    return (
        <PasswordContainer requiredRole="developer" isFullscreen={true}>
            <SettingsPageContainer
                buttons={[]}
                className="service-edit"
                backUrl={"/settings/advanced-settings"}
                style={null}
            >
                <div className="content-divider">
                    <div className="content-wrapper">
                        <SettingCheckBoxComponent
                            label={t("mouse_pointer")}
                            set={onChangeMousePointer}
                            value={mousePointer}
                        />
                    </div>
                    <div className="content-wrapper"></div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
